import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useAdminAuth } from '@/contexts/AdminAuthContext'
import { setAdminToken } from '@/api/adminClient'
import TabNav, { type Tab } from '@/components/admin/layout/TabNav'
import OverviewPage from '@/components/admin/dashboard/OverviewPage'
import DatabasePage from '@/components/admin/database/DatabasePage'
import FeedbackPage from '@/components/admin/feedback/FeedbackPage'
import IngestionPage from '@/components/admin/ingestion/IngestionPage'
import StandardsAccessPage from '@/components/admin/standards/StandardsAccessPage'

export default function AdminDashboardPage() {
  const { isAuthenticated, isLoading, accessToken, logout } = useAdminAuth()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<Tab>('overview')

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/admin/login', { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  useEffect(() => {
    setAdminToken(accessToken)
  }, [accessToken])

  async function handleLogout() {
    await logout()
    navigate('/admin/login', { replace: true })
  }

  if (isLoading || !isAuthenticated) return null

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center">
          <h1 className="text-lg font-semibold text-gray-800">Nemo Admin</h1>
          <button
            onClick={handleLogout}
            className="ml-auto flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </header>

      <TabNav activeTab={activeTab} onChange={setActiveTab} />

      <main className="max-w-7xl mx-auto px-6 py-6">
        {activeTab === 'overview'         && <OverviewPage />}
        {activeTab === 'database'         && <DatabasePage />}
        {activeTab === 'ingestion'        && <IngestionPage />}
        {activeTab === 'feedback'         && <FeedbackPage />}
        {activeTab === 'standards-access' && <StandardsAccessPage />}
      </main>
    </div>
  )
}
